import { render, staticRenderFns } from "./customPermissions.vue?vue&type=template&id=0e078d56&scoped=true&"
import script from "./customPermissions.vue?vue&type=script&lang=js&"
export * from "./customPermissions.vue?vue&type=script&lang=js&"
import style0 from "./customPermissions.vue?vue&type=style&index=0&id=0e078d56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e078d56",
  null
  
)

export default component.exports